import React, { useState, useEffect, useRef} from "react";
import { useRecoilState } from "recoil";
import { speedStringByType } from "../../plugins/common";
import { selectBedInfoState, measurementStateFamily } from '../../plugins/recoil';

import './DisplaySelect.scss';
import {ReactComponent as IconArrowUp} from '../../assets/icons/ic-arrow-up.svg'
import {ReactComponent as IconArrowDown} from '../../assets/icons/ic-arrow-down.svg'
import {ReactComponent as IconCheck} from '../../assets/icons/ic-check_blue.svg';

function DisplaySpeedSelect({waveType,value,index,handleChangeSelect}) {
    const selectRef = useRef();
    const [selectBedInfo, ] = useRecoilState(selectBedInfoState)
    const [measurementSettings, ] = useRecoilState(measurementStateFamily(selectBedInfo?.serial));
    const [optionList, setOptionList] = useState([])
    const [nowOption, setNowOption] = useState()
    const [isDropdownOpen, setIsDropdownOpen] = useState(false)
    const DropDownIndex = [0,1,2,6,7,8]

    const speedOptions = [
        { label: 6.25, value: 6.25 }, { label: 12.5, value: 12.5 }, { label: 25, value: 25 }, { label: 50, value: 50 }
    ]

    const handleClickOutside = (event) => {
        if (selectRef.current && !selectRef.current.contains(event.target)) {
            setIsDropdownOpen(false);
        }
    };

    useEffect(() => {
        setNowOption(measurementSettings[speedStringByType[waveType]])
    }, [isDropdownOpen, measurementSettings])

    useEffect(() => {
        setNowOption(measurementSettings[speedStringByType[waveType]])
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    return (             
        <div className={`relative h-[26px] w-[100px]`} ref={selectRef}>
            <div className="bg-gradient-to-b from-[#5E5E5E] to-[#383838] text-[#DEDEDE] h-[26px] px-[8px] rounded-[6px] cursor-pointer flex items-center border border-[#4E4E4E]" onClick={(e) => { e.stopPropagation(); setIsDropdownOpen((prev) => !prev);}}>                                
                <div className="">{nowOption}</div>
                <div className="">{ 'mm/s' }</div>
            </div>

            {
                isDropdownOpen && (
                    <div className={`w-[100px] custom-select ${DropDownIndex.includes(index) ? 'top-[30px]' : 'bottom-[30px]'} absolute h-[130px] overflow-y-auto over bg-[#1F1F1F] w-[130px] py-[8px] rounded-[6px] border border-[#5E5E5E] shadow-[0px_12px_12px_0px_rgba(0,0,0,0.4)] z-20`} onClick={(e) => { e.stopPropagation(); setIsDropdownOpen((prev) => !prev);}}>
                        {
                            speedOptions.map((option,optionIdx) => (
                                <div key={`paramter-speed-select-${index}-${optionIdx}`} className={`bg-[#1F1F1F] cursor-pointer h-[32px] flex items-center justify-between px-[8px] hover:bg-[#2F2F2F] ${option.value === nowOption ? "text-[#3182F7]" : "text-white"}`} onClick={(e) => { e.stopPropagation(); handleChangeSelect(waveType,index,option.value); (option.value !== nowOption && setIsDropdownOpen((prev) => !prev))}}>
                                    {option.label}   
                                    {option.value === nowOption && (
                                        <IconCheck className="w-4 h-4 ml-2" />
                                    )}                                 
                                </div>
                            ))
                        }
                    </div>
                )
            }
            <div className="absolute transform -translate-y-1/2 pointer-events-none top-1/2 right-2">
                {isDropdownOpen ?  <IconArrowUp/> : <IconArrowDown/>}
            </div>
        </div>

    );
}

export default DisplaySpeedSelect;
